module.exports = "pegasus/assets/lp/charity/logo.png";